import React from 'react';
import { FormControlLabel, Box } from '@mui/material';

import { Checkbox, CheckboxProps } from '@occc-app/design-system';

interface IProps {
  label: string | React.ReactNode;
}

export const FormCheckbox: React.FC<IProps & CheckboxProps> = ({ label, ...props }) => {
  return (
    <Box>
      <FormControlLabel control={<Checkbox color='primary' {...props} />} label={label} />
    </Box>
  );
};
